export default "__VITE_ASSET__Cf_do4ma__"